import { Domain } from '~/types/axis.types';

export interface DataObject {
  [key: string]: number;
}

export function extent(data: DataObject[], type = 'value'): Domain {
  if (!data[0].hasOwnProperty(type)) {
    throw new Error(`Object property "${type}" does not exist in data`);
  }

  let min = data[0][type];
  let max = data[0][type];

  for (const item of data) {
    if (item[type] < min) {
      min = item[type];
    }
    if (item[type] > max) {
      max = item[type];
    }
  }

  return [min, max];
}
